// extracted by mini-css-extract-plugin
export default {"wrapper":"ImagesCarousel_wrapper__To5jV","slide":"ImagesCarousel_slide__q--Pw"};